export const getConfig = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return {
    headers: {
      Authorization: `Bearer ${user && user.token ? user.token : ""}`,
      Accept: "application/json",
    },
  };
};

export const config = {
  get headers() {
    const user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    return {
      Authorization: `Bearer ${user && user.token ? user.token : ""}`,
      Accept: "application/json",
    };
  },
};

